<script setup lang="ts">
const shopStore = useShopStore()
</script>

<template>
  <Action action="setMyStore" variant="none" class="set-store">
    <svg-icon name="mhj:set-my-store-dark" class="set-store__icon--dark" />
    <svg-icon name="mhj:set-my-store" class="set-store__icon--light" />
    <span v-if="shopStore.myStoreName" class="set-store__text">
      <span class="set-store__text-label"> {{ $t('set_my_store.header_my_store') }}: </span>
      <span class="set-store__text-name">{{ shopStore.myStoreName.replace('Michael Hill ', '') }}</span>
    </span>
    <span v-else class="set-store__text">{{ $t('set_my_store.header_set_my_store') }}</span>
  </Action>
</template>

<style lang="postcss">
.set-store {
  display: flex;
  align-items: center;
  gap: 0;

  .set-store__icon--light {
    display: block;
    width: 1.2rem;
    margin-right: var(--space-30);
  }
  .set-store__icon--dark {
    display: none;
  }

  .set-store__text {
    max-width: 12ch;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    @media (--tablet) {
      max-width: none;
    }
  }

  .set-store__text span {
    text-decoration: underline;
  }

  .set-store__text-label {
    display: none;
    @media (--tablet) {
      display: inline;
    }
  }
}
</style>
